<div class="mt-20 bk-cust-video-wrap" *ngIf="url" [ngSwitch]="videoType">
   <ng-container *ngSwitchCase="'youtube'">
      <iframe class="bk-video-player" [src]="'https://www.youtube.com/embed/'+videoId+'?si=gNA-5XSzcu8XEJDd&amp' | safeHtml: 'resourceUrl'" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
      <script [src]="embedJsUrl" defer></script></ng-container>
   <ng-container *ngSwitchCase="'vimeo'">
      <iframe class="bk-video-player" [src]="'https://player.vimeo.com/video/'+videoId+'?h=a9a924c301' | safeHtml: 'resourceUrl'" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
      <script src="https://player.vimeo.com/api/player.js"></script>
   </ng-container>
   <ng-container *ngSwitchCase="'custom'">
      <video class="bk-video-player" id="preview" width="100%" height="100%" controls>
         <source [src]="imgBase+url" type="video/mp4">
      </video>
   </ng-container>
</div>

<style>
   .bk-video-player {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
   }
</style>